import { render, staticRenderFns } from "./coupon-more.vue?vue&type=template&id=2f1d23e8&scoped=true&lang=pug&"
import script from "./coupon-more.vue?vue&type=script&lang=js&"
export * from "./coupon-more.vue?vue&type=script&lang=js&"
import style0 from "./coupon-more.vue?vue&type=style&index=0&id=2f1d23e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d23e8",
  null
  
)

export default component.exports